import React from 'react';
import { ListGroup } from 'react-bootstrap';
import {
  COPY_CELL_DOWNWARDS,
  COPY_CELL_OTHERS,
  COPY_CELL_UPWARDS,
  COPY_ROW_DOWNWARDS,
  COPY_ROW_OTHERS,
  COPY_ROW_UPWARDS,
} from './constants';

export const CustomContextMenu = ({
  copyRow,
  copyCell,
  metaValuesLength,
  onContextFileIndex,
  intl,
}) => {
  return (
    <div>
      <ListGroup as="ul">
        <ListGroup.Item
          action
          as="li"
          onClick={() => {
            copyRow(COPY_ROW_UPWARDS);
          }}
          disabled={onContextFileIndex == 0}
        >
          {intl.formatMessage({ id: 'fileUploader.copyRowUp' })}
        </ListGroup.Item>
        <ListGroup.Item
          action
          as="li"
          onClick={() => {
            copyRow(COPY_ROW_DOWNWARDS);
          }}
          disabled={onContextFileIndex == metaValuesLength - 1}
        >
          {intl.formatMessage({ id: 'fileUploader.copyRowDown' })}
        </ListGroup.Item>
        <ListGroup.Item
          action
          as="li"
          onClick={() => {
            copyRow(COPY_ROW_OTHERS);
          }}
        >
          {intl.formatMessage({ id: 'fileUploader.copyRowToRows' })}
        </ListGroup.Item>
        <ListGroup.Item
          action
          as="li"
          onClick={() => {
            copyCell(COPY_CELL_UPWARDS);
          }}
          disabled={onContextFileIndex == 0}
        >
          {intl.formatMessage({ id: 'fileUploader.copyCellUp' })}
        </ListGroup.Item>
        <ListGroup.Item
          action
          as="li"
          onClick={() => {
            copyCell(COPY_CELL_DOWNWARDS);
          }}
          disabled={onContextFileIndex == metaValuesLength - 1}
        >
          {intl.formatMessage({ id: 'fileUploader.copyCellDown' })}
        </ListGroup.Item>
        <ListGroup.Item
          action
          as="li"
          onClick={() => {
            copyCell(COPY_CELL_OTHERS);
          }}
        >
          {intl.formatMessage({ id: 'fileUploader.copyCellToCell' })}
        </ListGroup.Item>
      </ListGroup>
    </div>
  );
};
